import React from 'react'

const PREVIEW_HOSTNAMES = ['venuemanagerpreview.cintoia.com', 'localhost', '127.0.0.1']
const BANNER_HEIGHT = 28

const PreviewBanner = () => {
  if (typeof window === 'undefined') return null
  if (!PREVIEW_HOSTNAMES.includes(window.location.hostname)) return null
  return (
    <div
      role='status'
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: BANNER_HEIGHT,
        zIndex: 2147483647,
        backgroundColor: '#f0ad4e',
        color: '#212529',
        textAlign: 'center',
        fontSize: 13,
        lineHeight: `${BANNER_HEIGHT}px`,
        padding: '0 8px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
        fontWeight: 500,
        pointerEvents: 'none',
      }}
    >
      Olet käyttämässä Venuemanagerin Preview versiota. Kaikki toiminnallisuudet eivät ole viimeisteltyjä.
    </div>
  )
}

export default PreviewBanner
